import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';

export default function Shared() {
  const { username, id } = useParams();

  return (
    <Box className="console-shell">
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Paper className="panel" elevation={0}>
          <Typography variant="h5" gutterBottom>Shared Recovery Payload</Typography>
          <Typography color="text.secondary" paragraph>
            Public recovery links are now served directly from the API share endpoint.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Request: {username}/{id}
          </Typography>
          <Button component={RouterLink} to="/" variant="contained">Back to console</Button>
        </Paper>
      </Container>
    </Box>
  );
}
